import SvgWave from "./SvgWave";

export default SvgWave;
